import { Component, forwardRef, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { AlgoStateFilterType } from "app/bfx-interface-controls/helpers/AlgoFilterHelper";
import {
  DEFAULT_CHANGE_CALLBACK,
  DEFAULT_TOUCH_CALLBACK,
  OnChangeCallbackType,
  OnTouchCallbackType,
} from "shared/base-components/models/ControlValueAccessorTypes";

@Component({
  selector: "bfx-algo-state-dropdown",
  template: `
    <bfx-dropdown-button
      [(ngModel)]="valueStr"
      [labels]="stateFilterTypes"
      (ngModelChange)="stateFilterChanged()"
      type="secondary"
      emphasis="bold"
      class="state-dropdown"
      title="Algo state filter"
    ></bfx-dropdown-button>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BfxAlgoStateDropdownComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class BfxAlgoStateDropdownComponent implements OnInit, ControlValueAccessor {
  /** ControlValueAccessor callback */
  public onModelChange: OnChangeCallbackType = DEFAULT_CHANGE_CALLBACK;

  /** ControlValueAccessor callback */
  public onModelTouched: OnTouchCallbackType = DEFAULT_TOUCH_CALLBACK;

  protected valueStr: string;

  private value: AlgoStateFilterType;

  public stateFilterTypes: string[];
  private valueMap: Map<string, AlgoStateFilterType> = new Map();

  constructor(private translate: TranslateService) {}

  private init() {}

  ngOnInit(): void {
    this.stateFilterTypes = [
      this.translate.instant("algo.filter.state.all"),
      this.translate.instant("algo.filter.state.active"),
      this.translate.instant("algo.filter.state.completed"),
    ];

    if (!Number.isInteger(this.value) || this.value < 0 || this.value > 2) {
      this.value = 0;
    }
    this.valueMap.set(this.stateFilterTypes[0], AlgoStateFilterType.ALL);
    this.valueMap.set(this.stateFilterTypes[1], AlgoStateFilterType.ACTIVE);
    this.valueMap.set(this.stateFilterTypes[2], AlgoStateFilterType.COMPLETED);

    this.valueStr = this.stateFilterTypes[this.value];
  }

  writeValue(value: AlgoStateFilterType): void {
    if (this.stateFilterTypes?.length > 0) {
      if (!Number.isInteger(value) || value < 0 || value > 2) {
        value = 0;
      }
      this.valueStr = this.stateFilterTypes[value];
      this.value = value;
    }
  }

  registerOnChange(fn: OnChangeCallbackType): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: OnTouchCallbackType): void {
    this.onModelTouched = fn;
  }

  protected stateFilterChanged() {
    if (this.valueMap.has(this.valueStr)) {
      this.value = this.valueMap.get(this.valueStr);
      this.onModelChange(this.value);
    }
  }
}
